// src/components/Blocks/SocialMeta/schema.js

const socialMetaSchema = {
  title: 'Social Media Meta',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'social_use_defaults',
        'social_image_source',
        'social_custom_title',
        'social_custom_description',
        'social_custom_image',
        'social_twitter_card',
        'social_global_site_name',
        'social_global_default_title',
        'social_global_default_description',
        'social_global_default_image',
        'social_global_twitter_handle',
      ],
    },
  ],
  properties: {
    social_use_defaults: {
      title: 'Social Sharing Settings',
      type: 'string',
      choices: [
        ['page', 'Use page title & description'],
        ['global', 'Use global defaults (set below)'],
        ['custom', 'Custom override for this page'],
      ],
      default: 'page',
    },
    social_image_source: {
      title: 'Social Image',
      type: 'string',
      choices: [
        ['leadImage', 'Use page lead/preview image'],
        ['globalDefault', 'Use global default image'],
        ['custom', 'Custom image for this page'],
      ],
      default: 'leadImage',
    },
    social_custom_title: {
      title: 'Social Sharing Title',
      description: 'Override title for social media sharing',
      type: 'string',
    },
    social_custom_description: {
      title: 'Social Sharing Description',
      description: 'Override description for social media sharing',
      type: 'string',
      widget: 'textarea',
    },
    social_custom_image: {
      title: 'Custom Social Image',
      description: 'Recommended size: 1200x630px',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
    social_twitter_card: {
      title: 'Twitter Card Type',
      type: 'string',
      choices: [
        ['summary', 'Summary'],
        ['summary_large_image', 'Summary with large image'],
      ],
      default: 'summary_large_image',
    },
    social_global_site_name: {
      title: 'Site Name',
      description: 'Used in Open Graph meta tags',
      type: 'string',
    },
    social_global_default_title: {
      title: 'Default Social Title',
      description: 'Fallback title when page has no title',
      type: 'string',
    },
    social_global_default_description: {
      title: 'Default Social Description',
      description: 'Fallback description when page has no description',
      type: 'string',
      widget: 'textarea',
    },
    social_global_default_image: {
      title: 'Default Social Image',
      description: 'Fallback image for social sharing (1200x630px recommended)',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
    social_global_twitter_handle: {
      title: 'Twitter Handle',
      description: 'Include the @ symbol (e.g., @yoursite)',
      type: 'string',
    },
  },
  required: [],
};

export default socialMetaSchema;